import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EditButton } from 'LegacyWeployDesignLanguage/buttons';
import Divider from 'LegacyWeployDesignLanguage/Divider';

import RoleSummary from './RoleSummary';

const RolesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${props => props.theme.space.half};
`;

const ButtonWrapper = styled.div`
  order: 1;
`;

const Roles = (props) => {
  const {
    roles,
    showTasks,
    showAchievements,
    searchTerms,
    onEdit,
  } = props;

  return (
    <Fragment>
      { roles.map((roleData, index) => {
        const {
          id,
          organisation,
          industry,
          title,
          startDate,
          endDate,
          tasks,
          achievements,
        } = roleData;

        const industryName = industry ? industry.name : ''; // So we don't break current search profile

        return (
          <RolesWrapper key={`${title}-${startDate}-${endDate}`}>
            {onEdit &&
              <ButtonWrapper>
                <EditButton onClick={() => onEdit(roleData)} />
              </ButtonWrapper>
            }
            <RoleSummary
              key={id}
              organisation={organisation}
              industry={industryName}
              title={title}
              startDate={startDate}
              endDate={endDate}
              tasks={showTasks ? tasks : null}
              achievements={showAchievements ? achievements : null}
              searchTerms={searchTerms}
            />
            { index < (roles.length - 1) && <Divider /> }
          </RolesWrapper>
        );
      })}
    </Fragment>
  );
};

Roles.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.object),
  showTasks: PropTypes.bool,
  showAchievements: PropTypes.bool,
  onEdit: PropTypes.func,
  searchTerms: PropTypes.arrayOf(PropTypes.string),
};

Roles.defaultProps = {
  showTasks: false,
  showAchievements: false,
  roles: [],
  onEdit: null,
  searchTerms: [],
};

export default Roles;
